import { FlexBox, Typography } from '@vp/swan'
import LinkWithIcon from './LinkWithIcon'
import type { HeaderLink } from '../../../types/site-header'

type HelpCenterProps = {
  helpLink: HeaderLink
  carePhoneNumber?: string | null
  siteHeaderHelpLinkA11YText?: string
}

export default function HelpCenter({ helpLink, carePhoneNumber = '', siteHeaderHelpLinkA11YText = '' }: HelpCenterProps) {
  return (
    <LinkWithIcon
      href={helpLink.url}
      iconType="helpQuery"
      analyticsId={helpLink.analyticsId || 'help'}
      accessibleLabel={siteHeaderHelpLinkA11YText?.replace('{{{phoneNumber}}}', carePhoneNumber!) || helpLink.text}
      label={
        <FlexBox flexDirection="column">
          <Typography aria-label={siteHeaderHelpLinkA11YText?.replace('{{{phoneNumber}}}', carePhoneNumber!)}>{helpLink.text}</Typography>
          <Typography textColor="subtle">{carePhoneNumber}</Typography>
        </FlexBox>
      }
    />
  )
}
